import { Tag } from 'antd';
import { UserType } from '@tcr-erp/shared';

export function normalizeCustomerType(value?: string | null): UserType {
  return value === UserType.ORGANIZATION || value === 'organization' || value === 'company'
    ? UserType.ORGANIZATION
    : UserType.PERSONAL;
}

export function getCustomerTypeLabel(value?: string | null): string {
  return normalizeCustomerType(value) === UserType.ORGANIZATION ? 'Tổ chức' : 'Cá nhân';
}

export function CustomerTypeBadge({ type }: { type?: string | null }) {
  const normalized = normalizeCustomerType(type);
  return (
    <Tag color={normalized === UserType.ORGANIZATION ? 'purple' : 'cyan'}>
      {getCustomerTypeLabel(normalized)}
    </Tag>
  );
}
